import { DOMcreateElement, Icon} from '@p4b/utils-jsx';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import { ControlPanel } from '@p4b/question-base';
import { translate } from '@p4b/utils-lang';
import { evaluate } from 'mathjs';
import { newUniqueName } from '@p4b/utils';
import { configInfoToolTab, configInfoToolText, configInfoToolButton } from './exam-accessibility';

const passive: AddEventListenerOptions | EventListenerOptions = {passive: true};

export class Calculator {
    private controlPanel: ControlPanel;
    private button: HTMLButtonElement;
    private panel: HTMLDivElement;
    private input: HTMLInputElement;
    private equals: HTMLButtonElement;
    private errorTimeout?: number | NodeJS.Timeout;

    public constructor(
        controlPanel: ControlPanel,
    ) {
        this.controlPanel = controlPanel;
        this.button = <button id="calc-button" className={configInfoToolTab}><Icon icon={faCalculator}/><span className="app-button-text">{translate('CONTROL_CALCULATOR')}</span></button>;
        this.input = <input id="calculator" type="text" size={20} className={"calc-text " + configInfoToolText} autocomplete={newUniqueName()} autocorrect="off" autocapitalize="off" spellcheck="false"/>;
        this.equals = <input id="equals" type="button" value="=" className={"calc-button nav-pad-left " + configInfoToolButton}/>;
        this.panel = <div className="calculator-bar" hidden={true}>{this.input}{this.equals}</div>;
        this.controlPanel.panel().appendChild(this.panel);
        this.controlPanel.add(this.button);
        this.button.addEventListener('click', this.handleClick);
        this.equals.addEventListener('click', this.handleEq, passive);
        this.input.addEventListener('keyup', this.handleText, passive);
    }

    private readonly handleClick = () => {
        this.panel.hidden = !this.panel.hidden;
        this.button.setAttribute('aria-pressed', String(!this.panel.hidden));
    }

    private showError(): void {
        if (this.errorTimeout) {
            clearTimeout(this.errorTimeout);
            this.errorTimeout = undefined;
        }

        this.input.classList.add('config-danger800-bg');

        this.errorTimeout = setTimeout(() => {
            this.input.classList.remove('config-danger800-bg');
            this.errorTimeout = undefined;
        }, 500);
    }

    private handleEq = (): void => {
        try {
            const result = evaluate(this.input.value || '0');

            if (typeof result === 'function') {
                this.showError();
            } else {
                this.input.value = String(result);
            }
        } catch(err) {
            console.warn(err);
            this.input.value = err instanceof Error ? err.message : String(err);
        }
    }

    private handleText = (event: KeyboardEvent): void => {
        if (event.key === 'Enter') {
            try {
                const result = evaluate(this.input.value || '0');

                if (typeof result === 'function') {
                    this.showError();
                } else {
                    this.input.value = String(result);
                }
            } catch(err) {
                console.warn(err);
                this.input.value = err instanceof Error ? err.message : String(err);
            }
        }
    }

    public disabled(disabled: boolean) {
        this.button.disabled = disabled;
        if (disabled) {
            this.panel.hidden = true;
        }
    }

    public destroy() {
        if (this.errorTimeout) {
            clearTimeout(this.errorTimeout);
            this.errorTimeout = undefined;
        }

        this.controlPanel.remove(this.button);
        this.controlPanel.panel().removeChild(this.panel);
        this.button.removeEventListener('click', this.handleClick);
        this.equals.removeEventListener('click', this.handleEq, passive);
        this.input.removeEventListener('keyup', this.handleText, passive);
    }
}